module.exports = __webpack_public_path__ + "img/bg.f737aba7.png";